import { AfterContentChecked, Component, Input, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-payments-payments-card',
  templateUrl: './payments-payments-card.component.html',
  styleUrls: ['./payments-payments-card.component.scss']
})
export class PaymentsPaymentsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  counter: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('payments-payments-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('payments-payments-spinner');
      this.showCounter = true;
      this.counter = this.data.length;
    } else if ('-' === this.data) {
      this.counter = '-';
      this.showCounter = true;
      this.spinnerService.hide('payments-payments-spinner');
    }
  }

}
